import Pagination from "./index.vue";

Pagination.install = Vue => Vue.component(Pagination.componentName, Pagination);

export default Pagination;
